export class PlaceAutocompleteAction
{
    shouldFetchSuggestions(formik_field)
    {
        return formik_field.length >= 3
    }


}